/* eslint-disable camelcase */
import type { IdentityProviderDto } from './dto';
import type { IdentityProviderModel } from './model';

export const identityProviderDtoToModel = ({
  id,
  login_id,
  display_name,
  organizations,
}: IdentityProviderDto): IdentityProviderModel => ({
  id,
  loginId: login_id,
  displayName: display_name,
  organizations,
});

export const identityProviderModelToDto = ({
  id,
  loginId,
  displayName,
  organizations,
}: IdentityProviderModel): IdentityProviderDto => ({
  id,
  login_id: loginId,
  display_name: displayName,
  organizations,
});
